import { render, staticRenderFns } from "./silvia.vue?vue&type=template&id=7f10de1e&scoped=true"
import script from "./silvia.vue?vue&type=script&lang=js"
export * from "./silvia.vue?vue&type=script&lang=js"
import style0 from "./silvia.vue?vue&type=style&index=0&id=7f10de1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10de1e",
  null
  
)

export default component.exports